// extracted by mini-css-extract-plugin
module.exports = {"cadReportBody":"CadReportBody_cadReportBody__1Pj5d","title":"CadReportBody_title__1o3zm"};